export default __webpack_public_path__ + "static/media/alawaji.49ce8ca0.svg";